// extracted by mini-css-extract-plugin
export var icon = "social-module--icon--Vo3zQ";
export var link = "social-module--link--oLTkA";
export var section = "social-module--section--sGRBi";
export var show = "social-module--show--wl3Og";